<template>
  <div class="ExpiredView">
    <generic-big-text
        :text="expiredText.text"></generic-big-text>
    <div class="container">
      <div class="socialBtnsContainer">
        <social-btns
          :key="componentKey"
          :share-url="shareUrl"
          :share-subject="shareSubject"
          :share-email-subject="shareEmailSubject"
          :share-email-body="shareEmailBody"></social-btns>
      </div>
    </div>
  </div>
</template>

<script>

  import GenericBigText from './generic_big_text'
  import SocialBtns from './social_btns'


  export default {
    name: 'ExpiredView',
    components:{
      GenericBigText,
      SocialBtns
    },

    data(){
      return {
        componentKey: 0
      }
    },
    methods: {
      forceRerender() {
        this.componentKey += 1;
      }
    },
    props: {
      expiredText: {
        type: Object,
        default: ()=>{}
      },
      shareUrl: {
        type: String,
        default: window.location.href
      },
      shareSubject: {
        type: String,
        default: ""
      },
      shareEmailSubject: {
        type: String,
        default: ""
      },
      shareEmailBody: {
        type: String,
        default: ""
      }
    },
    mounted(){
      var me = this;
      window.addEventListener('changeTab', function (e) {
        console.log('changeTab');
        me.forceRerender();
        setTimeout(()=>{
            if (typeof (Event) === 'function') {
              // Modern browsers
              window.dispatchEvent(new Event('resize'))
            } else {
              // Old browsers (especially IE)
              let resizeEvent = window.document.createEvent('UIEvents')
              resizeEvent.initUIEvent('resize', true, false, window, 0)
              window.dispatchEvent(resizeEvent)
            }
        },100)
      });
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';

  .ExpiredView{
    /deep/ .rrssb-buttons a{ height: auto; }
  }

  @media (min-width: @bootstrap-md){
    /deep/ .bg{
        padding-top: 80px !important;
    }
  }
</style>
